import React, { Dispatch, useState } from 'react';
import { ParentElement } from './ParentElemetn';
import { SearchTree } from '../../types/searchTree';
import { Organization } from '../../types/organization';

type handleProps = {
  id: number;
  type: string;
};

type ChangeOptions = {
  a: string;
  b: string;
};

type logsInfo = {
  id?: number;
  type?: number;
};
type UpdateEntity = {
  id: number;
  getTree(): void;
  type: number;
};
type dndProps = {
  setEmployeeInfoShow: Dispatch<boolean>;
  setOrgInfoShow: Dispatch<boolean>;
  orgArr: Organization[];
  handleSetStaff({ type, id }: logsInfo): void;
  handleOrganizationInfo({ id, type }: handleProps): void;
  handleChangeOptions({ a, b }: ChangeOptions): void;
  searchTree?: SearchTree;
  handleSetEntityLoader(val: boolean): void;
  entityLoader: boolean;
  handleChangeIsKarmaUser(
    id: number,
    type: number,
    value: boolean,
    handleGetTree: () => void,
  ): void;
  handleSetEntityUpdateArray({ id, getTree, type }: UpdateEntity): void;
  getEntityList(search?: URLSearchParams): Promise<void>;
};

export function CustomizedTreeView({
  setEmployeeInfoShow,
  setOrgInfoShow,
  orgArr,
  handleSetStaff,
  handleOrganizationInfo,
  handleChangeOptions,
  searchTree,
  handleChangeIsKarmaUser,
  handleSetEntityLoader,
  entityLoader,
  handleSetEntityUpdateArray,
  getEntityList,
}: dndProps) {
  const [clicked, setClicked] = useState<number[]>([]);
  const [showOrganization, setShowOrganization] = useState<boolean>(false);

  return (
    <>
      {searchTree ? (
        <ParentElement
          clicked={clicked}
          element={searchTree}
          // getEntity={getEntity}
          handleOrganizationInfo={handleOrganizationInfo}
          handleSetStaff={handleSetStaff}
          setClicked={setClicked}
          setEmployeeInfoShow={setEmployeeInfoShow}
          setOrgInfoShow={setOrgInfoShow}
          // tree={tree}
          handleChangeOptions={handleChangeOptions}
          handleChangeIsKarmaUser={handleChangeIsKarmaUser}
          handleSetEntityLoader={handleSetEntityLoader}
          entityLoader={entityLoader}
          handleSetEntityUpdateArray={handleSetEntityUpdateArray}
          getEntityList={getEntityList}
          showOrganization={showOrganization}
          setShowOrganization={setShowOrganization}
        />
      ) : (
        orgArr.map(
          (element) =>
            element.orgName === 'Группа ТМК' && (
              <ParentElement
                key={element.id}
                clicked={clicked}
                element={element}
                // getEntity={getEntity}
                handleOrganizationInfo={handleOrganizationInfo}
                handleSetStaff={handleSetStaff}
                setClicked={setClicked}
                setEmployeeInfoShow={setEmployeeInfoShow}
                setOrgInfoShow={setOrgInfoShow}
                // tree={tree}
                handleChangeOptions={handleChangeOptions}
                handleChangeIsKarmaUser={handleChangeIsKarmaUser}
                handleSetEntityLoader={handleSetEntityLoader}
                entityLoader={entityLoader}
                handleSetEntityUpdateArray={handleSetEntityUpdateArray}
                getEntityList={getEntityList}
                showOrganization={showOrganization}
                setShowOrganization={setShowOrganization}
              />
            ),
        )
      )}
      <div
        style={{
          paddingLeft: 30,
          display: showOrganization ? 'block' : 'none',
        }}
      >
        {!searchTree &&
          orgArr.map(
            (element) =>
              element.orgName !== 'Группа ТМК' && (
                <ParentElement
                  key={element.id}
                  clicked={clicked}
                  element={element}
                  // getEntity={getEntity}
                  handleOrganizationInfo={handleOrganizationInfo}
                  handleSetStaff={handleSetStaff}
                  setClicked={setClicked}
                  setEmployeeInfoShow={setEmployeeInfoShow}
                  setOrgInfoShow={setOrgInfoShow}
                  // tree={tree}
                  handleChangeOptions={handleChangeOptions}
                  handleChangeIsKarmaUser={handleChangeIsKarmaUser}
                  handleSetEntityLoader={handleSetEntityLoader}
                  entityLoader={entityLoader}
                  handleSetEntityUpdateArray={handleSetEntityUpdateArray}
                  getEntityList={getEntityList}
                  showOrganization={showOrganization}
                  setShowOrganization={setShowOrganization}
                />
              ),
          )}
      </div>
    </>
  );
}
